(function () {
    'use strict';

    Directives.ConversationNotificationDirective = function ConversationNotificationDirective() {
        // @ngInject
        function ConversationNotificationDirectiveControllerCtor($scope, $injector, moment, $translate, $state,
                                                                 AppStates, UsersManager, AnalyticsService, ConversationService, $timeout) {
            this.UsersManager = UsersManager;
            this.constructor.$super.call(this, $scope, $injector);
            this.__objectType = 'ConversationNotificationDirectiveController';

            this.moment = moment;
            this.$state = $state;
            this.$timeout = $timeout;
            this.AppStates = AppStates;
            this.ConversationService = ConversationService;
            this.AnalyticsService = AnalyticsService;
            this.currUser = this.UsersManager.getCurrUser();
            this.elapsedTimeInStep = null;
            this.$translate = $translate;

            this.message = null;
            this.linkUrl = null;
            this.stateToGoTo = null;
            this.stateParams = null;
            this.reformatDate();

            $scope.$watch('activityVm.showing', function (newVal, oldVal) {
                if (!oldVal && newVal) {
                    this.reformatDate();
                }
            }.bind(this));
        }

        var ConversationNotificationDirectiveController = Class(Controllers.BaseController, {
            constructor: ConversationNotificationDirectiveControllerCtor,

            reformatDate: function reformatDate() {
                this.elapsedTimeInStep = this.moment(this.model.created_at).fromNow();
            },

            goToAssociatedState: function goToAssociatedState() {

                this.ConversationService.openConversation(this.model.data.conversation_id);
                this.markAsRead();
                this.showing = false;
                this.toggleNotifications(false);
            },

            messageAsHtml: function messageAsHtml(model) {

                if (model.data.unread_count === 0) {
                    this.iconType = 'icon-hb-nx-messages';
                    return this.$translate.instant('ACTIVITY_NOTIFICATIONS._CONVERSATION_MESSAGE_EMPTY_');
                } else {
                    this.iconType = 'icon-hb-nx-messages';
                    return this.$translate.instant('ACTIVITY_NOTIFICATIONS._CONVERSATION_MESSAGE_', {
                        conversationTitle: model.data.conversation_title,
                        unreadCount: model.data.unread_count,
                        lastMessageId: model.data.last_read_message_id,
                        conversationId: model.data.conversation_id,
                        readAt: model.data.read_at

                    });
                }
            },

            notificationHeader: function notificationHeader(model) {
                return this.$translate.instant('ACTIVITY_NOTIFICATIONS._CONVERSATION_TITLE_', {
                    conversationTitle: model.data.conversation_title
                });
            },

            markAsRead: function markAsRead() {
                this.currUser.markConversationNotificationAsSeen(this.model.data.conversation_id);
                this.showMarkAsReadEmptyState = true;
            }
        });

        return {
            restrict: 'E',
            templateUrl: 'angular/app/modules/core/features/activity_notifications/conversation_notification_directive_template.html',
            controller: ConversationNotificationDirectiveController,
            controllerAs: 'conversationVm',
            bindToController: true,
            scope: {
                model: '=model',
                showing: '=showing',
                showMarkAsReadEmptyState:'=showMarkAsReadEmptyState',
                toggleNotifications: '&'
            }
        };
    };
}());

